


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { CostCenterForm } from '@/models/config'

// Components
import { FormCreateEditCostCenter } from '@/components/config'

@Component({
    name: 'ModalCreateEditCostCenter',
    components: {
        FormCreateEditCostCenter
    }
})
export default class ModalCreateEditCostCenter extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) costCenter!: CostCenterForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear nuevo centro de costo'
        }
        return 'Editar centro de costo'
    }
}
